webpackJsonp([263791100135453],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Tech from '../components/tech'
	
	var About = function About() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'div',
	      { className: 'row' },
	      Glamor.createElement(
	        'h2',
	        null,
	        'About Me'
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'columns eight' },
	        Glamor.createElement(
	          'p',
	          { className: 'centeredP' },
	          'I grew up in the foothills of Los Angeles. I have a love for the beach and a passion for technology. I\'ve had an interest in technology all my life. In college I spent most of my free time learning about different programming languages, tech stacks, and machine learning algorithms.'
	        ),
	        Glamor.createElement(
	          'p',
	          { className: 'centeredP' },
	          'Since graduating I have been building websites for people. When I don\'t have work I keep busy working on side projects of my own and reading articles about web technologies.'
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'columns four' },
	        Glamor.createElement(
	          'div',
	          { className: 'centeredImg' },
	          Glamor.createElement('img', {
	            // className="centeredImg"
	            src: '../website_resources/scaled.jpg',
	            alt: 'Profile picture'
	          })
	        )
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { className: 'row' },
	      Glamor.createElement(
	        'div',
	        { className: 'columns twelve' },
	        Glamor.createElement(
	          'h2',
	          null,
	          'Education'
	        ),
	        Glamor.createElement(
	          'div',
	          { className: 'timeline-wrap ' },
	          Glamor.createElement(
	            'div',
	            { className: 'timeline-block' },
	            Glamor.createElement(
	              'div',
	              { className: 'timeline-ico' },
	              Glamor.createElement('div', { className: 'timeline-ico2' }),
	              Glamor.createElement('i', { className: 'fa fa-graduation-cap' })
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'timeline-content' },
	              Glamor.createElement(
	                'h2',
	                { className: '' },
	                'University of California, Santa Cruz'
	              ),
	              Glamor.createElement(
	                'h3',
	                { id: 'p-one' },
	                'Bachelor of Science'
	              ),
	              Glamor.createElement(
	                'h4',
	                { id: 'p-two' },
	                'Computer Science'
	              ),
	              Glamor.createElement('br', null),
	              Glamor.createElement('br', null),
	              Glamor.createElement(
	                'p',
	                { id: 'p-one' },
	                'Degree Awarded: '
	              ),
	              Glamor.createElement(
	                'p',
	                { id: 'p-two' },
	                'March 2018'
	              ),
	              Glamor.createElement('br', null),
	              Glamor.createElement('br', null),
	              Glamor.createElement(
	                'p',
	                { id: 'p-one' },
	                'Began Studies: '
	              ),
	              Glamor.createElement(
	                'p',
	                { id: 'p-two' },
	                'June 2016'
	              )
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { className: 'timeline-block' },
	            Glamor.createElement(
	              'div',
	              { className: 'timeline-ico' },
	              Glamor.createElement('div', { className: 'timeline-ico2' }),
	              Glamor.createElement('i', { className: 'fa fa-graduation-cap' })
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'timeline-content' },
	              Glamor.createElement(
	                'h2',
	                { className: '' },
	                'Glendale Community College'
	              ),
	              Glamor.createElement(
	                'h3',
	                { id: 'p-one' },
	                'Associate of Science'
	              ),
	              Glamor.createElement(
	                'h4',
	                { id: 'p-two' },
	                'Mathematics'
	              ),
	              Glamor.createElement('br', null),
	              Glamor.createElement('br', null),
	              Glamor.createElement(
	                'p',
	                { id: 'p-one' },
	                'Degree Awarded: '
	              ),
	              Glamor.createElement(
	                'p',
	                { id: 'p-two' },
	                'June 2016'
	              ),
	              Glamor.createElement('br', null),
	              Glamor.createElement('br', null),
	              Glamor.createElement(
	                'p',
	                { id: 'p-one' },
	                'Began Studies: '
	              ),
	              Glamor.createElement(
	                'p',
	                { id: 'p-two' },
	                'Februrary 2013'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-f0317d68b31758212c26.js